import { useEffect, useState } from "react";
import { FiCopy, handleCopy } from "@/components/common/commonFunction/handleCopy";

function getSecureRandomInt(min, max) {
  if (min >= max) {
    throw new Error("The 'min' value must be less than 'max'.");
  }

  const range = max - min + 1;
  const randomBuffer = new Uint32Array(1);

  window.crypto.getRandomValues(randomBuffer);

  const randomValue = randomBuffer[0] / (0xffffffff + 1);

  return Math.floor(randomValue * range) + min;
}
function generate(n) {
  let add = 1,
    max = 12 - add;

  if (n > max) {
    return generate(max) + generate(n - max);
  }

  max = Math.pow(10, n + add);
  let min = max / 10;
  let number = getSecureRandomInt(min, max);

  return ("" + number).substring(add);
}

export default function GenerateRandomNumber(Data) {
  const [copy, setCopy] = useState(false);
  const [count, setCount] = useState(null);
  const [digit, setDigit] = useState(null);
  const [answer, setAnswer] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    return () => {
      setCount(null);
      setDigit(null);
      setAnswer(null);
      setCopy(false);
    };
  }, [Data]);

  const handleOnClick = () => {
    if (!validateForm()) return;
    setCopy(false);
    const generatedAnswers = Array.from({ length: count }, () =>
      generate(Number(digit))
    );
    setAnswer(generatedAnswers.join(" "));
  };
  const validateForm = () => {
    let formIsValid = true;
    let err = {};

    if (!digit) {
      err.digitsnumber = "* Please enter number";
      formIsValid = false;
    }
    if (!count) {
      err.countNumber = "* Please enter number";
      formIsValid = false;
    }

    setErrors(err);
    return formIsValid;
  };

  return (
    <>
      <div className="commom-box-new aritmetic-top-alignment">
        <div className="aritmetic-two-col-grid">
          <div className="aritmetic-two-col-grid-items">
            <div className="input-new">
              <label>How many digits in number</label>
              <input
                placeholder="Enter a number"
                type="number"
                name="digitsnumber"
                onChange={(e) => {
                  setDigit(e.target.value);
                  setCopy(false);
                  setAnswer("");
                  setErrors({ ...errors, [e.target.name]: "" });
                }}
                className={errors?.digitsnumber && "error-input"}
              />
              <span className="text-sm text-red-700">
                {errors?.digitsnumber}
              </span>
            </div>
          </div>
          <div className="aritmetic-two-col-grid-items">
            <div className="input-new">
              <label>Total count of random number (100)</label>
              <input
                placeholder="Enter a number"
                type="number"
                name="countNumber"
                onChange={(e) => {
                  setCount(e.target.value);
                  setCopy(false);
                  setErrors({ ...errors, [e.target.name]: "" });
                  setAnswer("");
                }}
                className={errors?.countNumber && "error-input"}
              />
              <span className="text-sm text-red-700">
                {errors?.countNumber}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="button arithmetic-button-center-alignment-new-one">
        <button onClick={handleOnClick}>Generate Now</button>
      </div>
      {answer && (
        <div className="commom-box-new">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(answer)} />
            {copy && (
              <div>
                {" "}
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="input-new">
            <textarea
              placeholder="Answer"
              value={answer}
              disabled
              className="text-black"
            ></textarea>
          </div>
        </div>
      )}
    </>
  );
}
